module.exports = require('shared/components/abstract').extend({})


// WEBPACK FOOTER //
// ./assets/js/shared_frontend/components/abstract/index.coffee